define('lq/events/actions/setVisibility',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    var opposites = {
        'top': 'bottom',
        'bottom': 'top',
        'left': 'right',
        'right': 'left'
    };

    var hasEnoughRoomAtTheRight = function (parameters, requiredSpace) {
        return parameters.srcElementX - parameters.scrollLeft + requiredSpace <= parameters.windowWidth;
    };

    var hasEnoughRoomAtTheLeft = function (parameters, requiredSpace) {
        return parameters.srcElementX - parameters.scrollLeft - requiredSpace >= 0;
    };

    var hasEnoughRoomAtTheBottom = function (parameters, requiredSpace) {
        return parameters.srcElementY - parameters.scrollTop + requiredSpace <= parameters.windowHeight;
    };

    var hasEnoughRoomAtTheTop = function (parameters, requiredSpace) {
        return parameters.srcElementY - parameters.scrollTop - requiredSpace >= 0;
    };

    var hasEnoughRoomAtLeftOrRight = function (direction, parameters) {
        return direction === 'right' ?
            hasEnoughRoomAtTheLeft(parameters, parameters.targetElementWidth - parameters.srcElementWidth)
                : hasEnoughRoomAtTheRight(parameters, parameters.targetElementWidth);
    };

    var hasEnoughRoomAtTopOrBottom = function (direction, parameters) {
        return direction === 'top' ?
            hasEnoughRoomAtTheBottom(parameters, parameters.targetElementHeight)
            : hasEnoughRoomAtTheTop(parameters, parameters.targetElementHeight - parameters.srcElementHeight);
    };

    var hasEnoughRoom = function (parameters, positionA, positionB) {
        if (positionA === 'right') {
            return hasEnoughRoomAtTheRight(parameters, parameters.srcElementWidth + parameters.targetElementWidth)
                && hasEnoughRoomAtTopOrBottom(positionB, parameters);
        } else if (positionA === 'left') {
            return hasEnoughRoomAtTheLeft(parameters, parameters.targetElementWidth)
                && hasEnoughRoomAtTopOrBottom(positionB, parameters);
        } else if (positionA === 'top') {
            return hasEnoughRoomAtTheTop(parameters, parameters.targetElementHeight)
                && hasEnoughRoomAtLeftOrRight(positionB, parameters);
        } else if (positionA === 'bottom') {
            return hasEnoughRoomAtTheBottom(parameters, parameters.srcElementHeight + parameters.targetElementHeight)
                && hasEnoughRoomAtLeftOrRight(positionB, parameters);
        }

        return true;
    };

    var determinePosition = function (parameters, positionA, positionB, offset) {
        var targetPosition = {
            top: null,
            left: null,
            right: null,
            bottom: null
        };

        if (positionA === 'cover' && positionB === 'cover') {
            targetPosition.left = parameters.srcElementX + ((parameters.srcElementWidth - parameters.targetElementWidth) / 2);
            targetPosition.top = parameters.srcElementY + ((parameters.srcElementHeight - parameters.targetElementHeight) / 2);
        } else if (positionA === 'coverleft' && positionB === 'covertop') {
            targetPosition.left = parameters.srcElementX + offset;
            targetPosition.top = parameters.srcElementY + offset;
        } else if (positionA === 'coverright' && positionB === 'covertop') {
            targetPosition.left = parameters.srcElementX - parameters.targetElementWidth + parameters.srcElementWidth - offset;
            targetPosition.top = parameters.srcElementY + offset;
        } else if (positionA === 'coverright' && positionB === 'coverbottom') {
            targetPosition.left = parameters.srcElementX - parameters.targetElementWidth + parameters.srcElementWidth - offset;
            targetPosition.top = parameters.srcElementY - parameters.targetElementHeight + parameters.srcElementHeight - offset;
        } else if (positionA === 'coverleft' && positionB === 'coverbottom') {
            targetPosition.left = parameters.srcElementX + offset;
            targetPosition.top = parameters.srcElementY - parameters.targetElementHeight + parameters.srcElementHeight - offset;
        } else if (positionA === 'right') {
            targetPosition.left = parameters.srcElementX + parameters.srcElementWidth + offset;

            if (positionB === 'top')
                targetPosition.top = parameters.srcElementY;
            else
                targetPosition.bottom = parameters.windowHeight - parameters.srcElementY - parameters.srcElementHeight;
        } else if (positionA === 'left') {
            targetPosition.right = parameters.windowWidth - parameters.srcElementX + offset;

            if (positionB === 'top')
                targetPosition.top = parameters.srcElementY;
            else
                targetPosition.bottom = parameters.windowHeight - parameters.srcElementY - parameters.srcElementHeight;
        } else if (positionA === 'top') {
            targetPosition.bottom = parameters.windowHeight - parameters.srcElementY + offset;

            if (positionB === 'left')
                targetPosition.left = parameters.srcElementX;
            else
                targetPosition.right = parameters.windowWidth - parameters.srcElementX - parameters.srcElementWidth;
        } else if (positionA === 'bottom') {
            targetPosition.top = parameters.srcElementY + parameters.srcElementHeight + offset;

            if (positionB === 'left')
                targetPosition.left = parameters.srcElementX;
            else
                targetPosition.right = parameters.windowWidth - parameters.srcElementX - parameters.srcElementWidth;
        }

        return targetPosition;
    };

    var getBestPosition = function (eventSource, drop) {
        var preferedPositionA = drop.data.autoPosition.preferedPositionA;
        var preferedPositionB = drop.data.autoPosition.preferedPositionB;

        var allPositions = [
            { a: preferedPositionA, b: preferedPositionB },
            { a: preferedPositionA, b: opposites[preferedPositionB] },
            { a: opposites[preferedPositionA], b: preferedPositionB },
            { a: opposites[preferedPositionA], b: opposites[preferedPositionB] },
            { a: preferedPositionB, b: preferedPositionA },
            { a: preferedPositionB, b: opposites[preferedPositionA] },
            { a: opposites[preferedPositionB], b: preferedPositionA },
            { a: opposites[preferedPositionB], b: opposites[preferedPositionA] }
        ];

        var $window = $(window);

        var parameters = {
            windowWidth: $('#theBody').width(),
            windowHeight: $('#theBody').height(),

            scrollTop: drop.piping.$app.scrollTop(),
            scrollLeft: drop.piping.$app.scrollLeft(),

            srcElementX: eventSource.activeArea.left,
            srcElementY: eventSource.activeArea.top,
            srcElementHeight: eventSource.activeArea.height,
            srcElementWidth: eventSource.activeArea.width,

            targetElementHeight: drop.$element.height(),
            targetElementWidth: drop.$element.width()
        };

        if (drop.data.autoPosition && eventSource.eventPosition && drop.data.autoPosition.position === 'Mouse click') {
            parameters.srcElementX = eventSource.eventPosition.clientX;
            parameters.srcElementY = eventSource.eventPosition.clientY;
            parameters.srcElementHeight = 0;
            parameters.srcElementWidth = 0;
        }

        for (var i = 0; i < allPositions.length; i++) {
            var position = allPositions[i];

            if (hasEnoughRoom(parameters, position.a, position.b))
                return determinePosition(parameters, position.a, position.b, (drop.data.autoPosition.offset ?? 0));
        }

        return determinePosition(parameters, preferedPositionA, preferedPositionB, (drop.data.autoPosition.offset ?? 0));
    };

    function SetVisibility(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(SetVisibility, EventAction);

    SetVisibility.typeName = 'SetVisibility';

    SetVisibility.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    SetVisibility.prototype.execute = function (continuation) {
        var drop = this.piping.dropFactory.findDropById(this.eventData.morphId);

        if (this.eventSource && (!drop || (drop.piping.idOfItem && this.eventSource.drop.piping.idOfItem))) {
            var parentContainer = this.eventSource.drop.getFirstParentOfType("ListItem");

            if (parentContainer) {
                var dropId = this.eventData.morphId;
                drop = parentContainer.findChildDropWhere(function (candidateDrop) {
                    return candidateDrop.data.id === dropId;
                });
            }
        }

        if (drop) {
            if (this.eventData.showMorph || (this.eventData.showMorph === null && drop.isHidden)) {

                if (drop.data.autoPosition && drop.data.autoPosition.enabled) {
                    var targetPosition = getBestPosition(this.eventSource, drop);
                    drop.autoPositionAt(targetPosition);
                }

                Promise.resolve(drop.show())
                    .then(continuation);
            } else {
                drop.hide();
                continuation();
            }
        } else {
            continuation();
        }
    };

    return SetVisibility;
});
